exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "start-screen-area{display:flex}start-screen-area .title-item{min-width:290px;padding-top:10px}start-screen-area .md-input-invalid label,start-screen-area .ng-invalid{border-color:#dd2c00!important}start-screen-area .ng-invalid{border-width:0 0 2px!important}start-screen-area .upload-container{position:relative;top:-10px}start-screen-area .upload-container .file-title{width:100%!important;margin-left:10px!important;min-width:200px!important;font-size:12px;color:gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/start-screen-area/start-screen-area.scss
// module id = 724
// module chunks = 0